/**
 * Caps a mental wellbeing indicator score based on GAD-2/PHQ-2 thresholds
 * so the visual indicator lands in the correct colour zone.
 *
 * Zones (per business rules):
 *  - RED:   score < 20  (GAD-2 or PHQ-2 >= 3)
 *  - AMBER: score 20–60 (GAD-2 or PHQ-2 >= 1)
 *  - GREEN: score > 60  (both 0)
 */
export function capMentalWellbeingScore(
  rawScore: number,
  gad2Score: number,
  phq2Score: number
): number {
  let score = rawScore;
  if (gad2Score >= 1 || phq2Score >= 1) {
    score = Math.min(55, score);
  }
  if (gad2Score >= 3 || phq2Score >= 3) {
    score = Math.min(15, score);
  }
  return score;
}
